export const shouldUpdateFn = (fields: string[]) => (prev: Record<string, any>, next: Record<string, any>) => {
  return fields.some((key) => prev[key] !== next[key])
}
